import { render, staticRenderFns } from "./projectXinFeng.vue?vue&type=template&id=ff459bb4&scoped=true&"
import script from "./projectXinFeng.vue?vue&type=script&lang=js&"
export * from "./projectXinFeng.vue?vue&type=script&lang=js&"
import style0 from "./projectXinFeng.vue?vue&type=style&index=0&id=ff459bb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff459bb4",
  null
  
)

export default component.exports